import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import ItemList from '../../Form/ItemList';
import { toJS } from 'mobx';

@inject('stationTypeStore')
@observer
class StationTypeList extends Component {
  render() {
    const { stationTypeStore, children } = this.props;
    let data = Object.assign([], toJS(stationTypeStore.items)).map(item => {
      item.icon = item.icon ? <img src={`data:image/svg+xml;utf8,${encodeURIComponent(item.icon)}`} style={{ width: '15px', height: '15px' }} alt='not-found' /> : '';
      item.parent = stationTypeStore.findById(item.parent_id);
      return item
    })


    return (
      <ItemList
        store={stationTypeStore}
        data={data}
        columns={[
          { key: 'id', label: 'ID' },
          { key: 'name', label: 'Name' },
          { key: 'description', label: 'Description' },
          { key: 'parent.name', label: 'Parent Type' },
          { key: 'icon', label: 'Icon' }
        ]}
        slug={'configurations/station-type'}
        resource={'configurations'}
        children={children}
        allowAdd
        allowEdit
        allowDelete
      />

    );
  }
}

export default StationTypeList;



// WEBPACK FOOTER //
// ./src/components/Station/Type/StationTypeList.js